import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { forwardRef } from 'react';
/**
 * Input primitive. Emits `data-ui-input` so the host stylesheet can
 * theme it. Forwards the underlying `<input>` ref so callers can attach
 * imperative APIs (e.g. Google Places Autocomplete) to the element.
 */
export const Input = forwardRef(function Input(props, ref) {
    return _jsx("input", { ref: ref, "data-ui-input": "", ...props });
});
//# sourceMappingURL=Input.js.map